/**
* 新增/修改水印
*/
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import { Form, Spin } from 'antd';
import moment from 'moment'
import columns from './columns'
import './index.less'

let { WizContainer, modelUtils } = framework_tool;
let { Session } = utils_tool
let { WizCard, WizForm, WizButton } = component_tool;

class DailyDetailInfo extends WizContainer {
    componentName = 'WatermarkDetailInfo';

    constructor(props) {
        super(props);
        const { history } = props
        let initialValue = {}
        if (history.location && history.location.pathname === '/watermark/update') {
            if (history.location && history.location.record) {
                initialValue = history.location.record
                Session.set('WatermarkDetailInfo', initialValue)
            } else {
                initialValue = Session.get('WatermarkDetailInfo') || {}
            }
        }
        this.state = {
            initialValue: initialValue || {},
            watermarkType: initialValue.shape ? initialValue.shape : 0
        };
    }
    propsAndStateOnChange = {
        addWatermark: this._watermarkHandle.bind(this, 'addWatermark'),
        updWatermark: this._watermarkHandle.bind(this, 'updWatermark')
    };

    _componentDidMount() {

    }

    /**
    * 新增/修改成功返回原页面，失败弹出提示
    */
    _watermarkHandle(key, nextProps, nextState,) {
        let _key = nextProps[key]
        let { code, msg } = _key
        if (code == 1) {
            wizNotice.success('保存成功');
            this.jumpPage('replace', '/watermark');
        } else {
            wizNotice.error(msg || '提交失败');
        }
        return true;
    }

    _save(values) {
        const { history } = this.props;
        let apiPath = 'watermarkManager/add';
        let payloadKey = 'watermarkManagerAdd';
        if (history.location && history.location.pathname === '/watermark/update') {
            apiPath = 'watermarkManager/upd';
            payloadKey = 'watermarkManagerUpd';
        }
        this.doAction({
            path: apiPath,
            payload: {
                key: payloadKey,
                apiParams: {
                    ...values
                }
            }
        });
    };


    /**
    * 处理表单提交事件
    */
    handleSubmit = e => {
        // e.preventDefault();
        this.formData.validateFields((err, values) => {
            let addCmd = Object.assign({}, values)
            if (!err) {
                console.log('-------', addCmd)
                this._save(addCmd)
            }
        });
    };

    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <div style={{ textAlign: 'center' }}>
                <WizButton style={{ marginLeft: 20 }} title='保存' type='primary' htmlType='submit'>保存</WizButton>
                <WizButton style={{ marginLeft: 20 }} onClick={() => { this.jumpPage('replace', '/watermark'); }}>返回</WizButton>
            </div>

        )

    }
    _render() {
        let { initialValue } = this.state
        let formProps = {
            ref: 'form',
            columns: columns(this, initialValue),
            onSubmit: this.handleSubmit,
            record: null,
            preview: null,
            footer: null,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        };
        return (
            <WizCard>
                <Spin tip={'加载中'} spinning={false}>
                    <WizForm
                        className='watermark-detail-form'
                        {...formProps}
                        ref={r => {
                            this.formData = r
                        }}>
                        {this._submit()}
                    </WizForm>
                </Spin>
            </WizCard>)
    }
}

const mapStateToProps = (state, ownProps) => {
    const { watermarkManager } = state;
    const addWatermark = modelUtils.getModelEntity(watermarkManager, 'watermarkManagerAdd');
    const updWatermark = modelUtils.getModelEntity(watermarkManager, 'watermarkManagerUpd');
    const load = modelUtils.getLoadingState(state, ['watermarkManager']);
    return {
        addWatermark,
        updWatermark,
        ...load
    }
};

export default connect(mapStateToProps)(DailyDetailInfo);